import React from "react";
import { RadioButton } from "./../index";
import styles from "./styles.module.scss";
import { Spacing } from "spacing/component";
import { LabelFont } from "VideoWall/components/fonts";

interface IProps {
  title?: string;
  items: Array<{
    label?: string;
    name?: string;
    value: string | number;
    id: string | undefined;
  }>;
  selectedValue: string | number | undefined;
  selectedValueChanged: (value: string | number) => void;
}

export const RadioButtonGroup = ({
  items,
  title,
  selectedValue,
  selectedValueChanged
}: IProps) => (
  <div className={styles.root}>
    {title && (
      <Spacing pb="3xs">
        <LabelFont>{title}</LabelFont>
      </Spacing>
    )}
    {items.map(rb => (
      <Spacing pv="5xs">
        <RadioButton
          key={rb.id}
          onClick={() => selectedValueChanged(rb.value)}
          checked={rb.value === selectedValue}
          {...rb}
        />
      </Spacing>
    ))}
  </div>
);
